import React from "react"
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material"
import { commonDateFormat, DDMMYYYY } from "../../utils/constants"
import moment from "moment"
import { Link } from "react-router-dom"

export const CommonTable = ({
  rowData = [],
  headerKeys = [],
  rowComponent,
  onPressRow = () => {},
  observerRef,
  loadingStatus="hide"
}) => {
  return (
    <TableContainer
      sx={{
        width: { lg: "50%", md: "60%", sm: "80%", xs: "100%" },
      }}
    >
      <Table
        aria-label="simple table"
        stickyHeader
        sx={{ height: "auto", border: "solid 1px lightgrey" }}
      >
        <TableHead>
          <TableRow sx={{ backgroundColor: "#dfdfdd" }}>
            {headerKeys.map((key) => (
              <TableCell sx={{ fontWeight: 600, backgroundColor: "inherit" }}>
                {key}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowData?.map((each) => (
            <TableRow
              sx={{
                ":hover": {
                  backgroundColor: "#e8e9eb",
                },
                cursor: "pointer",
              }}
              onClick={() => onPressRow(each)}
            >
              {rowComponent(each)}
            </TableRow>
          ))}
          <TableRow ref={observerRef} />
          <TableRow style={{display: loadingStatus==="hide" ? "none": "table-row" }}>
          <TableCell 
            colSpan={headerKeys.length} 
            sx={{ 
              textAlign: 'center', 
              // padding: '20px',
              height: '40px',
              border: 'none'
            }}
          >
            <CircularProgress sx={{display: loadingStatus==="loading" ? "block" : "none", margin: "auto"}} />
          </TableCell>
        </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export const PatientTableRow = ({ rowData }) => (
  <>
    <TableCell>{rowData?.patientId ?? ""}</TableCell>
    <TableCell>{`${rowData?.firstName ?? ""} ${
      rowData?.lastName ?? ""
    }`}</TableCell>
    <TableCell>
      <Typography>
        {rowData?.dateOfBirth ? 
          `${moment(rowData?.dateOfBirth, commonDateFormat).format(commonDateFormat)}` 
          : 
          "NA"
        }
      </Typography>
    </TableCell>
  </>
)

export const DoctorTableRow = ({ rowData }) => {
  return (
    <>
      <TableCell sx={{ width: "60%" }}>{`${rowData?.firstName ?? ""} ${
        rowData?.lastName ?? ""
      }`}</TableCell>
      <TableCell sx={{ width: "40%" }}>{rowData?.role ?? ""}</TableCell>
    </>
  )
}

export const InVoiceTableRow = ({ rowData, onViewPress }) => {
  return (
    <>
      <TableCell>{`${rowData?.patientFirstName ?? ""} ${
        rowData?.patientLastName ?? ""
      }`}</TableCell>
      <TableCell>{rowData?.patientId ?? ""}</TableCell>
      <TableCell
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography>£{rowData?.amount ?? ""}</Typography>
        <Button onClick={() => onViewPress(rowData)}>View</Button>
      </TableCell>
    </>
  )
}
